// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + ".chunk.css?v=" + {"node_modules_emotion_react_jsx-runtime_dist_emotion-react-jsx-runtime_browser_esm_js-node_mod-a8a5ba":"00e28ff7","node_modules_vmos2_design-system_src_grid_styles_module_scss":"00e28ff7"}[chunkId] + "";
};